// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__SVD4s","modal":"Modal_modal__YFIXl"};